import { API_BASE_URL, fetchAuthenticated } from "./config";

// Starts the QuickBooks OAuth flow. Used both for connecting a new company
// and reconnecting one whose refresh token expired — Intuit's consent screen
// handles both the same way and the callback upserts the token row.
export async function startQuickBooksConnect() {
  const res = await fetchAuthenticated(`${API_BASE_URL}/quickbooks/login`);
  const data = await res.json();
  if (!data.redirectUrl) {
    throw new Error("No redirect URL returned from QuickBooks login");
  }
  window.location.href = data.redirectUrl;
}
